import { useCallback } from 'react';
import { getABTest } from '../utils';
import { useTracking } from './useTracking';
// Utilities to emit tracking events from outside of Builder.io kit component renderers.
export const useBuilderIOKitTracking = ({ content, serviceName, }) => {
    const { emitUserInteractionEvent, emitPageViewEvent } = useTracking();
    const _emitPageViewEvent = useCallback((eventDetails) => {
        const abTest = getABTest(content);
        return emitPageViewEvent(Object.assign(Object.assign({}, eventDetails), { experiment_name: abTest.experiment_name, experiment_flag: abTest.experiment_flag, system_name: serviceName }));
    }, [serviceName, emitPageViewEvent, content]);
    return {
        emitPageViewEvent: _emitPageViewEvent,
        getEmitUserInteractionEvent: (block) => (eventDetails) => {
            var _a, _b;
            const freshABTest = getABTest(content);
            const component_name = (_a = block === null || block === void 0 ? void 0 : block.component) === null || _a === void 0 ? void 0 : _a.name;
            const layer_name = (_b = block === null || block === void 0 ? void 0 : block.layerName) !== null && _b !== void 0 ? _b : component_name;
            emitUserInteractionEvent(Object.assign(Object.assign({}, eventDetails), { system_name: serviceName, experiment_flag: freshABTest.experiment_flag, experiment_name: freshABTest.experiment_name, custom_tracking_fields: Object.assign({ component_name,
                    layer_name, model: content === null || content === void 0 ? void 0 : content.model }, eventDetails.custom_tracking_fields) }));
        },
    };
};
//# sourceMappingURL=useBuilderIOKitTracking.js.map